/* eslint-disable max-len */
import * as Cognito from "providers/cognito";
import { useLocaleState, useSidebarState, useTranslate } from "react-admin";
import { LogoutIcon, TranslateIcon } from "assets/Icons";
import * as User from "providers/user";
import { HelpOutline } from "@mui/icons-material";

interface LogoutAndLanguageProps {
  isMobileView?: boolean;
  closeProfilePopover: () => void;
}

const LogoutAndLanguage: React.FC<LogoutAndLanguageProps> = ({
  isMobileView,
  closeProfilePopover
}) => {
  const { signOut } = Cognito.useCognito();
  const [locale, setLocale] = useLocaleState();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_open, setOpen] = useSidebarState();
  const translate = useTranslate();
  const { setShowOnboarding, permissions } = User.useUser();
  return (
    <div>
      <div
        className={`flex w-[90px] items-center gap-[14px] group my-[16px] cursor-pointer ${
          isMobileView ? "ml-[16px]" : "ml-[4px]"
        } mr-[6px]`}
        onClick={() => {
          signOut();
          setOpen(false);
        }}
        aria-hidden
      >
        <LogoutIcon />
        <span
          className="text-[12px] font-normal font-['Inter'] whitespace-nowrap group-hover:!text-mono-black"
          style={{ color: "rgba(48, 47, 46, 0.6)" }}
        >
          {translate("navigation.log_out")}
        </span>
      </div>
      <div
        className={`flex items-center w-[160px] gap-[5px] ${
          isMobileView ? "ml-[16px]" : "ml-[4px]"
        } mr-[6px] mb-[12px]`}
      >
        <TranslateIcon className="mr-[6px]" />
        <span
          className={`text-[12px] font-normal font-['Inter'] whitespace-nowrap cursor-pointer ${
            locale === "en" ? "" : "hover:!text-mono-black"
          }`}
          style={{
            color: locale === "en" ? "#B8722A" : "rgba(48, 47, 46, 0.6)"
          }}
          onClick={() => setLocale("en")}
          aria-hidden
        >
          English
        </span>
        <span
          className="pointer-events-none text-[12px] font-normal font-['Inter'] whitespace-nowrap group-hover:!text-mono-black"
          style={{ color: "rgba(48, 47, 46, 0.6)" }}
        >
          /
        </span>
        <span
          className={`text-[12px] font-normal font-['Inter'] whitespace-nowrap cursor-pointer ${
            locale === "vi" ? "" : "text-mono-750 hover:!text-mono-black"
          }`}
          style={{
            color: locale === "vi" ? "#B8722A" : "rgba(48, 47, 46, 0.6)"
          }}
          onClick={() => setLocale("vi")}
          aria-hidden
        >
          {translate("navigation.Vietnamese")}
        </span>
      </div>
      {!permissions?.isArtist && (
        <div
          className={`flex w-[90px] items-center gap-[8px] group my-[16px] cursor-pointer ${
            isMobileView ? "ml-[16px]" : "ml-[4px]"
          } mr-[6px]`}
          onClick={() => {
            setShowOnboarding(true);
            closeProfilePopover();
          }}
          aria-hidden
        >
          <HelpOutline
            style={{
              color: "#302F2E",
              width: "20px",
              height: "20px",
              opacity: 0.56
            }}
          />
          <span
            className="text-[12px] font-normal font-['Inter'] whitespace-nowrap group-hover:!text-mono-black"
            style={{ color: "rgba(48, 47, 46, 0.6)" }}
          >
            Guide
          </span>
        </div>
      )}
      {isMobileView && <div className="h-px w-full mb-[8px] bg-mono-100" />}
      {isMobileView && (
        <div className="mb-[16px] ml-[16px] mr-[6px]">
          <span
            className="text-[12px] font-normal font-['Inter'] whitespace-nowrap hover:underline cursor-pointer"
            style={{ color: "rgba(48, 47, 46, 0.95)" }}
          >
            {translate("navigation.Support")}{" "}
          </span>
          <span
            className="text-[12px] font-normal font-['Inter'] whitespace-nowrap"
            style={{ color: "rgba(48, 47, 46, 0.4)" }}
          >
            • {translate("navigation.Version")} 0.0.1
          </span>
        </div>
      )}
    </div>
  );
};

export default LogoutAndLanguage;
